import { lazy } from "solid-js";

const QrCode = lazy(async () => import("./QrCode"));

export default QrCode;
